'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Components


// Helpers


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _editor = require('../../components/editor');

var _elementUtil = require('../elementUtil');

var _ColorBar = require('../../components/colors/ColorBar');

var _ColorBar2 = _interopRequireDefault(_ColorBar);

var _Caption = require('../../components/caption/Caption');

var _Caption2 = _interopRequireDefault(_Caption);

var _ElementUserTag = require('../../user/userActivity/ElementUserTag');

var _ElementUserTag2 = _interopRequireDefault(_ElementUserTag);

var _gridUtils = require('../../utils/grid/gridUtils');

var _elementCaptionUtil = require('../../components/caption/elementCaptionUtil');

var _cardConstants = require('../../../common/cards/cardConstants');

require('./Card.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = function Card(props) {
    var element = props.element,
        gridSize = props.gridSize,
        inList = props.inList,
        isEditing = props.isEditing,
        startEditing = props.startEditing,
        saveContent = props.saveContent,
        stopEditing = props.stopEditing,
        isEditable = props.isEditable,
        moveElementToTrash = props.moveElementToTrash,
        currentEditorKey = props.currentEditorKey,
        createNewCard = props.createNewCard,
        elementEvents = props.elementEvents;


    var classes = (0, _elementUtil.elementClassNames)('Card drag-handle', props);

    var colorName = element.getIn(['content', 'color']);
    var captionContent = (0, _elementCaptionUtil.getCaption)(element);
    var captionVisible = (0, _elementCaptionUtil.getShowCaption)(element);

    return _react2.default.createElement(
        'div',
        _extends({ id: (0, _elementUtil.getDomElementId)(element.get('id')), className: classes }, elementEvents, {
            style: (0, _gridUtils.getElementStyle)(34, gridSize, inList) }),
        _react2.default.createElement(_ColorBar2.default, { colorName: colorName }),
        _react2.default.createElement(_ElementUserTag2.default, props),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_editor.RichTextEditor, {
                className: 'cardContent',
                textContent: element.getIn(['content', 'textContent']),
                isEditing: isEditing,
                saveContent: saveContent,
                startEditing: startEditing,
                stopEditing: stopEditing,
                isEditable: isEditable,
                onEmptyBackspace: moveElementToTrash,
                editorId: element.get('id') + '-' + _cardConstants.CARD_TYPE,
                editorKey: _cardConstants.CARD_TYPE,
                currentEditorKey: currentEditorKey,
                createNewCard: createNewCard })
        ),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_Caption2.default, _extends({}, props, {
                showDivider: true,
                textContent: captionContent,
                captionVisible: captionVisible }))
        )
    );
};

Card.propTypes = {
    element: _propTypes2.default.object.isRequired,
    gridSize: _propTypes2.default.number,
    inList: _propTypes2.default.string,
    isSelected: _propTypes2.default.bool,
    isEditing: _propTypes2.default.bool,
    isEditable: _propTypes2.default.bool,
    isHovered: _propTypes2.default.bool,
    startEditing: _propTypes2.default.func,
    stopEditing: _propTypes2.default.func,
    saveContent: _propTypes2.default.func,
    moveElementToTrash: _propTypes2.default.func,
    documentMode: _propTypes2.default.bool,
    currentEditorKey: _propTypes2.default.string,
    createNewCard: _propTypes2.default.func,
    onEmptyBackspace: _propTypes2.default.func,
    saveCaptionContent: _propTypes2.default.func,
    elementEvents: _propTypes2.default.object
};

exports.default = Card;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/card/Card.js
// module id = 722
// module chunks = 0